<template>
  <section>
    <div class="row no-padd" ref="pessoaForm" v-if="matricula && pessoa">
      <div class="col-md-12 form-group no-padd-left checks" v-if="branch == 'filiacao1' || branch == 'filiacao2'">
        <label class="check-control">
          <input
            type="checkbox"
            class="check"
            :checked="pessoa.responsavel.pedagogico == 1"
            @change="pessoa.responsavel.pedagogico = $event.target.checked ? 1 : 0"
          >
          <span>É Responsável Pedagógico</span>
        </label>
        <label class="check-control">
          <input
            type="checkbox"
            class="check"
            :checked="pessoa.responsavel.financeiro == 1"
            @change="pessoa.responsavel.financeiro = $event.target.checked ? 1 : 0"
          >
          <span>É Responsável Financeiro</span>
        </label>
      </div>
      <div class="col-md-4 form-group no-padd-left">
        <label v-if="branch == 'responsavelFinanceiro' || branch == 'filiacao1' || branch == 'filiacao2'">CPF/CNPJ</label>
        <label v-else>CPF</label>
        <input-control
          v-model="pessoa.documento.cpf"
          placeholder="000.000.000-00"
          name="cpf"
          type="text"
          :valid="valid.cpf"
          :disabled="loadingInputContent || highrequire || action == 'ver' || isBasicPessoaBranch"
          @keyup="valid.cpf = true"
          @onsearch="search('cpf',$event)"
          @focus="triggerTip(branch,'cpf'); triggerCpfChange('record')"
          @change="triggerCpfChange('change'); personType()"
          masking="cpf"
          :search="!highrequire && !auto"
          :required="requireCPF()"
        />
        <input type="hidden" name="tipo" v-model="pessoa.Basicos.tipo " />
      </div>
      <div class="col-md-3 form-group no-padd-left" v-if="isBasicAlunoBranch">
        <label>Unidade</label>
        <select-control
          v-model="matricula[branch].aluno.idUnidade"
          :options="options.unidades"
          placeholder="Selecione"
          name="idUnidade"
          type="text"
          :valid="valid.idUnidade"
          :readonly="ro"
          :disabled="loadingInputContent || action == 'ver'"
          @change="valid.idUnidade = true"
          @focus="triggerTip(branch,'idUnidade')"
          required
        />
      </div>
      <div 
        class="col-md-4 form-group no-padd-left" 
          v-if="
            !auto &&
            (
              branch == 'responsavelFinanceiro' ||
              ((branch == 'filiacao1' || branch == 'filiacao2') && pessoa.responsavel.financeiro == 1)
            ) &&
            pessoa.documento.possuiRestricao == null
          ">
        <div class="cpfValidatinWrap">
          <a href="#" class="btn btn-primary" @click.prevent="validarFiscal()">
            Validar Situação Fiscal &nbsp; <fa :icon="['fas','file-invoice-dollar']" />
          </a>
        </div>
      </div>
      <!-- quebra linha -->
      <div class="w-100 d-none d-md-block"></div>

      <div class="col-md-5 form-group no-padd-left">
        <label>Nome Completo</label>
        <input-control
          v-model="pessoa.Basicos.nomeDocumento"
          placeholder="Nome do documento"
          name="nome"
          type="text"
          :valid="valid.nome"
          :readonly="ro"
          :disabled="loadingInputContent || highrequire || action == 'ver' || ( isAlunoBranch && auto )"
          @keyup="valid.nome = true"
          @change="changeName()"
          @focus="triggerTip(branch,'nome')"
          required
        />
      </div>
      <div class="col-md-5 form-group no-padd-left">
        <label>Nome Social</label>
        <input-control
          v-model="pessoa.Basicos.nome"
          placeholder="Como gostaria de ser chamado"
          :readonly="ro"
          :disabled="loadingInputContent || action == 'ver' || auto"
          @focus="triggerTip(branch,'nomeSocial')"
          name="nomeSocial"
          type="text"
        />
      </div>
      <div class="col-md-2 form-group no-padd-left" v-if="branch == 'responsavelFinanceiro' || ( isBasicPessoaBranch && !isAlunoBranch )|| pessoa.responsavel?.financeiro == 1 && !auto">
        <label>Código Perseus (resCodigo)</label>
        <input-control
          v-model="pessoa.Basicos.rescodigo"
          placeholder="12345"
          :readonly="ro"
          :disabled="loadingInputContent || action == 'ver' || auto"
          name="rescodigo"
          type="text"
        />
      </div>
      <div class="col-md-2 form-group no-padd-left" v-if="isAlunoBranch">
        <label>RA</label>
        <input-control
          v-model="matricula[branch].aluno.ra"
          placeholder="RA"
          :readonly="ro"
          :disabled="loadingInputContent || action == 'ver' || auto"
          name="ra"
          type="text"
        />
      </div>
      <div class="col-md-3 form-group no-padd-left">
        <label>Nacionalidade</label>
        <select-control
          v-model="pessoa.Basicos.idNacionalidade"
          :options="options.nacionalidades"
          placeholder="Selecione"
          name="idNacionalidade"
          type="text"
          :valid="valid.idNacionalidade"
          :readonly="ro"
          :disabled="loadingInputContent || action == 'ver'"
          @change="valid.idNacionalidade = true"
          @focus="triggerTip(branch,'idNacionalidade')"
          required
        />
      </div>
      <div class="col-md-3 form-group no-padd-left">
        <label>Data de Nascimento</label>
        <input-control
          v-model="pessoa.Basicos.dataNascimento"
          placeholder="DD/MM/YYYY"
          name="dataNascimento"
          type="date"
          :valid="valid.dataNascimento"
          :readonly="ro"
          :disabled="loadingInputContent || action == 'ver'"
          @keyup="valid.dataNascimento = true"
          @focus="triggerTip(branch,'dataNascimento')"
          required
        />
      </div>
      <div class="col-md-3 form-group no-padd-left">
        <label>Identidade de Gênero</label>
        <select-control
          v-model="pessoa.Basicos.sexo"
          :options="options.generos"
          placeholder="Selecione"
          name="sexo"
          type="text"
          :valid="valid.sexo"
          :readonly="ro"
          :disabled="loadingInputContent || action == 'ver'"
          @change="valid.sexo = true"
          @focus="triggerTip(branch,'sexo')"
          required
        />
      </div>
      <div class="col-md-3 form-group no-padd-left">
        <label>Raça/Cor</label>
        <select-control
          v-model="pessoa.Basicos.idRacaCor"
          :options="options.raca"
          placeholder="Selecione"
          name="idRacacor"
          type="text"
          :valid="valid.idRacacor"
          :readonly="ro"
          :disabled="loadingInputContent || action == 'ver'"
          @change="valid.idRacacor = true"
          required
        />
      </div>
      <div class="col-md-4 form-group no-padd-left">
        <label>CIN / RG</label>
        <input-control
          v-model="pessoa.documento.rg"
          placeholder=""
          name="rg"
          type="text"
          :readonly="ro"
          :disabled="loadingInputContent || action == 'ver'"
          :valid="valid.rg"
          @keyup="valid.rg = true"
          @focus="triggerTip(branch,'rg')"
          :required="!lowrequire && !isCNPJ"
        />
      </div>
      <div class="col-md-4 form-group no-padd-left">
        <label>Órgão Emissor</label>
        <select-control
          v-model="pessoa.documento.rgEmissor"
          :options="options.orgaosEmissores"
          placeholder="Selecione"
          name="rgEmissor"
          type="text"
          :valid="valid.rgEmissor"
          :readonly="ro"
          :disabled="loadingInputContent || action == 'ver'"
          @keyup="valid.orgaoEmissor = true"
          @focus="triggerTip(branch,'rgEmissor')"
          :required="!lowrequire && !isCNPJ"
        />
      </div>
      <div class="col-md-4 form-group no-padd-left" v-if="!isAlunoBranch">
        <div class="input-button-wrap">
          <div>
            <label>E-mail</label>
            <input-control
              v-model="pessoa.Basicos.email"
              placeholder="rafinha@email.com.br"
              :readonly="ro"
              :disabled="loadingInputContent || ( lowrequire && auto ) || action == 'ver'"
              :valid="valid.email"
              @keyup="valid.email = true"
              @focus="triggerTip(branch,'email')"
              name="email"
              type="text"
              :required="!lowrequire"
            />
          </div>
          <div v-if="
            !auto &&
            (
              branch == 'responsavelFinanceiro' ||
              ((branch == 'filiacao1' || branch == 'filiacao2') && pessoa.responsavel?.financeiro == 1)
            )
          ">
            <a
              href="#"
              :class="[
                'btn', 
                { 
                  'btn-primary': canValidateContent('email'),
                  'btn-success': hasValidatorContent('email') && isValidatorContentValidated('email'),
                  'btn-secondary': !hasValidatorContent('email'),
                  disabled: !canValidateContent('email') 
                }
              ]"
              @click.prevent="toggleValidator('email')"
            >
              {{ hasValidatorContent('email') && isValidatorContentValidated('email') ? 'Validado' : 'Validar' }}
            </a>
          </div>
        </div>
      </div>
      <div class="col-md-4 form-group no-padd-left" v-if="showEmailAcademico">
        <label>Email Acadêmico</label>
        <input-control
          v-model="pessoa.aluno.emailAcademico"
          placeholder="rafinha@email.com.br"
          :readonly="ro"
          :disabled="isBasicAlunoBranch || loadingInputContent || ( lowrequire && auto ) || action == 'ver'"
          :valid="valid.email"
          @keyup="valid.email = true"
          @focus="triggerTip(branch,'email')"
          name="email"
          type="text"
          :required="!lowrequire"
        />
      </div>
      <div class="col-md-4 form-group no-padd-left" v-if="!isAlunoBranch">
        <label>Telefone Residencial</label>
        <input-control
          v-model="pessoa.Basicos.telefonefixo"
          placeholder="(11) 3456 7890"
          name="telefonefixo"
          type="text"
          masking="fixo"
          :readonly="ro"
          :disabled="loadingInputContent || action == 'ver'"
          @keydown="addCountryCode('telefonefixo', $event)"
          @focus="triggerTip(branch,'telefonefixo')"
        />
      </div>
      <div class="col-md-4 form-group no-padd-left" v-if="!isAlunoBranch">
        <div class="input-button-wrap">
          <div>
            <label>Telefone Celular</label>
            <input-control
              v-model="pessoa.Basicos.telefonecelular"
              placeholder="(11) 9 8765 4321"
              name="telefonecelular"
              type="text"
              masking="celular"
              :valid="valid.telefonecelular"
              @keyup="valid.telefonecelular = true"
              @keydown="addCountryCode('telefonecelular', $event)"
              @focus="triggerTip(branch,'telefonecelular')"
              :readonly="ro"
              :disabled="loadingInputContent || action == 'ver'"
              :required="!lowrequire"
            />
          </div>
          <div v-if="
            !auto &&
            (
              branch == 'responsavelFinanceiro' ||
              ((branch == 'filiacao1' || branch == 'filiacao2') && pessoa.responsavel?.financeiro == 1)
            )
          ">
            <a
              href="#"
              :class="[
                'btn', 
                { 
                  'btn-primary': canValidateContent('telefonecelular'),
                  'btn-success': hasValidatorContent('telefonecelular') && isValidatorContentValidated('telefonecelular'),
                  'btn-secondary': !hasValidatorContent('telefonecelular'),
                  disabled: !canValidateContent('telefonecelular') 
                }
              ]"
              @click.prevent="toggleValidator('telefonecelular')"
            >
              {{ hasValidatorContent('telefonecelular') && isValidatorContentValidated('telefonecelular') ? 'Validado' : 'Validar' }}
            </a>
          </div>
        </div>
      </div>
      <div class="col-md-4 form-group no-padd-left" v-if="isAlunoBranch">
        <label>Escola Anterior</label>
        <input-control
          v-model="matricula[branch].aluno.escolaAnterior"
          placeholder="Colégio..."
          :readonly="ro"
          :disabled="loadingInputContent || action == 'ver' || auto"
          name="ra"
          type="text"
        />
      </div>
      <div class="col-md-4 form-group no-padd-left" v-if="( trackResp && !auto ) || ( branch == 'responsavelFinanceiro' && !auto ) || ( pessoa.responsavel?.financeiro == 1 && !auto)">
        <label>Dia vencimento mensalidade</label>
        <!-- <template v-if="vencimentoResponsavel">
          <input-control
            v-model="pessoa.responsavel.diavencimento"
            placeholder="Ex. 5"
            name="diavencimento"
            type="number"
            @keyup="validateDiaVencimento"
            :readonly="ro"
            :disabled="loadingInputContent || action == 'ver'"
          />
        </template>
        <template v-else>
          
        </template> -->
        <select-control
          v-model="pessoa.responsavel.diavencimento"
          :options="options.vencimentos"
          placeholder="Selecione"
          name="diavencimento"
          type="text"
          :readonly="ro"
          :disabled="loadingInputContent"
          @focus="triggerTip(branch,'diavencimento')"
          :required="!lowrequire"
        />
      </div>
      <div class="col-md-3 form-group no-padd-left" v-if="( trackResp && !auto ) || ( branch == 'responsavelFinanceiro' && !auto ) || ( pessoa.responsavel?.financeiro == 1 && !auto )">
        <label>Quantidade de residentes (incluindo o aluno)</label>
        <input-control
          v-model="pessoa.Basicos.quantidadeResidentes"
          placeholder="Selecione"
          name="quantidadeResidentes"
          type="number"
          :readonly="ro"
          :disabled="loadingInputContent || action == 'ver'"
          :valid="valid.quantidadeResidentes"
          @keyup="valid.quantidadeResidentes = true"
          required
        />
      </div>
      <div class="col-md-3 form-group no-padd-left" v-if="( trackResp && !auto ) || ( branch == 'responsavelFinanceiro' && !auto ) || ( pessoa.responsavel?.financeiro == 1 && !auto )">
        <label>Renda mensal média da família</label>
        <input-control
          v-model="pessoa.Basicos.rendaFamiliar"
          placeholder="2"
          name="rendaFamiliar"
          type="text"
          ismoney
          :readonly="ro"
          :disabled="loadingInputContent || action == 'ver'"
          :valid="valid.rendaFamiliar"
          @keyup="valid.rendaFamiliar = true"
          required
        />
      </div>
    </div>
    <confirm ref="confirm"></confirm>
    <modal ref="modal" wrapped>
      <validator :type="validatorType" :content="validatorContent" @validated="handleValidatorValidated" v-if="validatorOn"/>
    </modal>
  </section>
</template>

<script>
import UserService from '@/services/user.service'
import FormService from '@/services/form.service'
import MatriculaService from '@/services/matricula.service'
import { createSelectOptions, clearMask, unformatDate } from '@/services/utils.service'
import Confirm from '@/components/utilities/Confirm'
import matriculaService from '@/services/matricula.service'
import Validator from '../utilities/Validator.vue'
import Modal from '@/components/utilities/Modal.vue'

export default {
  components: {
    Confirm, Validator, Modal
  },
  props: {
    branch: String,
    child: String,
    lowrequire: {
      type: Boolean,
      default: false
    },
    highrequire: {
      type: Boolean,
      default: false
    },
    trackResp: {
      type: Boolean,
      default: false
    },
    auto: {
      type: Boolean,
      default: false
    },
    idMatricula: [String, Number],
    action: String,
    loadPessoa: {
      type: Object,
      default: null
    }
  },
  data () {
    return {
      valid: {
        nome: true,
        nomeSocial: true,
        idNacionalidade: true,
        dataNascimento: true,
        sexo: true,
        cpf: true,
        rg: true,
        rgEmissor: true,
        email: true,
        telefonecelular: true,
        idUnidade: true,
        idRacacor: true,
        rendaFamiliar: true,
        escolaAnterior: true
      },
      options: {
        nacionalidades: [],
        orgaosEmissores: [],
        generos: [
          { label: 'Feminino', value: 'F' },
          { label: 'Masculino', value: 'M' },
          { label: 'Outros', value: 'O' }
        ],
        vencimentos: [
          { label: '5', value: 5 },
          { label: '10', value: 10 },
          { label: '15', value: 15 },
          { label: '20', value: 20 },
          { label: '30', value: 30 }
        ],
        unidades: []
      },
      wait: {
        nacionalidades: false,
        orgaosEmissores: false,
        racaCor: false,
        classeSocial: false,
        unidades: true
      },
      matricula: null,
      loadingInputContent: false,
      isRespPed: false,
      isRespFin: false,
      cpfBkp: null,
      updateDiaVencimento: false,
      vencimentoResponsavel: false,
      vencimentoResponsavelTotal: false,
      diaVencimentoBkp: null,
      isCNPJ: false,
      pessoa: null,
      validatorOn: false,
      validatorType: null,
      validatorContent: null
    }
  },
  computed: {
    // pessoa () {
    //   if (!this.matricula) return null
    //   return this.child
    //     ? this.matricula[this.branch]?.[this.child]
    //     : this.matricula[this.branch]
    // },
    docReady () {
      const doc = this.pessoa?.documento?.cpf
      if (!doc) return false
      const clean = clearMask('cpf', doc)
      return clean.length === 11 || clean.length === 14
    },
    ro () {
      return !this.docReady
    },
    isAlunoBranch () {
      return this.branch === 'aluno' || this.branch === 'BasicAluno'
    },
    isBasicAlunoBranch () {
      return this.branch === 'BasicAluno'
    },
    showEmailAcademico () {
      return this.isBasicAlunoBranch || (this.isAlunoBranch && this.matricula.matricula.idSituacao == 1)
    },
    isBasicPessoaBranch () {
      return this.branch === 'Basic' || this.branch === 'BasicAluno'
    }
  },
  mounted () {
    this.updateDiaVencimento = UserService.filterPermissions('updateDiaVencimento')
    this.vencimentoResponsavel = UserService.filterPermissions('vencimentoResponsavel')
    this.vencimentoResponsavelTotal = UserService.filterPermissions('vencimentoResponsavelTotal')


    this.$store.dispatch('matricula/get').then(response => {
      console.log("matricula on pessoas:", response)
      this.matricula = response
      this.pessoa = response[this.branch]

      // window.spinner.emit("open")
      this.loadingInputContent = true
      if ( this.isBasicAlunoBranch ) this.wait.unidades = false
      this.getNacionalidades()
      this.getOrgaosEmissores()
      this.getRacaCor()
      if ( this.isBasicAlunoBranch ) this.getUnidades()
      this.personType()

      // console.log("Matricula ->", this.matricula)

      if ( this.child && this.trackResp ) {
        const resp = this.pessoa.Responsavel
        if ( resp.diavencimento && resp.diavencimento != 5 && resp.diavencimento != 10 ) {
          this.options.vencimentos.push({ label: resp.diavencimento.toString(), value: resp.diavencimento })
        } else {
          resp.diavencimento = resp.diavencimento || 5
        }
        this.diaVencimentoBkp = resp.diavencimento
      }

      if ( this.branch == 'responsavelFinanceiro' ) {
        const resp = this.pessoa.responsavel
        if ( resp.diavencimento && resp.diavencimento != 5 && resp.diavencimento != 10 ) {
          this.options.vencimentos.push({ label: resp.diavencimento.toString(), value: resp.diavencimento })
        } else {
          resp.diavencimento = resp.diavencimento || 5
        }
        this.diaVencimentoBkp = resp.diavencimento
      }

      if ( this.branch == 'filiacao1' || this.branch == 'filiacao2' || this.branch == 'responsavelFinanceiro' ) {
        this.getClassesSocial()
      } else {
        this.wait.classeSocial = true
      }
      
      if(this.loadPessoa && this.loadPessoa.documento?.cpf) {
        Object.assign(this.matricula[this.branch], this.loadPessoa)
        window.spinner.emit("close")
      }
    })
  },
  methods: {
    getNacionalidades () {
      UserService.nacionalidades().then(
        response => {
          if ( response.data.length > 0 ) {
            this.wait.nacionalidades = true
            this.options.nacionalidades = createSelectOptions(response.data,'idNacionalidade', 'descricao')
          }
          this.stopSpinner()
        },
        error => {
          console.error(error)
          window.spinner.emit("close")
        }
      )
    },
    getOrgaosEmissores () {
      UserService.orgaosEmissores().then(
        response => {
          if ( response.data.length > 0 ) {
            this.wait.orgaosEmissores = true
            this.options.orgaosEmissores = createSelectOptions(response.data,'idorgaoemissor', 'nome')
          }
          this.stopSpinner()
        },
        error => {
          console.error(error)
          window.spinner.emit("close")
        }
      )
    },
    getRacaCor () {
      UserService.racaCor().then(
        response => {
          console.log("racaCor:", response.data)
          if ( response.data.length > 0 ) {
            this.wait.racaCor = true
            this.options.raca = createSelectOptions(response.data,'idRacaCor', 'descricao')
          }
          this.stopSpinner()
        },
        error => {
          console.error(error)
          window.spinner.emit("close")
        }
      )
    },
    getClassesSocial () {
      UserService.racaCor().then(
        response => {
          if ( response.data.length > 0 ) {
            this.wait.classeSocial = true
            this.options.raca = createSelectOptions(response.data,'idRacaCor', 'descricao')
          } else {
            this.wait.classeSocial = true
          }
          this.stopSpinner()
        },
        error => {
          console.error(error)
          this.wait.classeSocial = true
          this.stopSpinner()
        }
      )
    },
    getUnidades () {
      MatriculaService.getUnidades().then(
        response => {
          if ( response.data.length > 0 ) {
            this.options.unidades = createSelectOptions(response.data, 'idUnidade', 'descricao')
          }
          this.wait.unidades = true
          this.stopSpinner()
        },
        error => {
          console.error(error)
          this.wait.unidades = true
          this.stopSpinner()
        }
      )
    },
    search ( by ) {
      if ( by === 'nome' ) {
        const nome = this.pessoa.Basicos.nomeDocumento
        if ( nome && nome.length > 3 ) {
          // window.spinner.emit('open')
          MatriculaService.getPessoaByNome( nome ).then(
            response => {
              console.log("getPessoaByCpfOuNome - nome:", response.data)
              if ( response.data.dados ) {
                this.$refs.confirm.run({
                  message: "Encontramos uma pessoa com este nome:<br><span class='color-text'>" + nome.toUpperCase() + "</span><br>Você deseja auto-preencher os campos do fomulário com os dados desta pessoa?",
                  confirmButton: "Sim",
                  denyButton: "Não",
                  callback: this.populate,
                  data: response.data,
                  size: 'mid'
                })
              }
              window.spinner.emit('close')
            },
            error => {
              console.error(error)
              window.spinner.emit('close')

              this.$store.dispatch('matricula/clear', this.branch).then( response => {
                console.log("dispatch clear", response)
                console.log("dispatch branch", this.branch)
                this.pessoa = response
                
                window.toaster.emit('open', {style: "error", message: "Não encontramos ninguém com o nome informado.", floater: true})

                setTimeout(() => {
                  this.$emit('clearEndereco',response.endereco)
                },1000)
              })
            }
          )
        }
      }

      if ( by === 'cpf' ) {
        const cpf = this.pessoa.documento.cpf
        if ( cpf && ( cpf.length == 14 || cpf.length == 18 ) ) {
          const drop = clearMask('cpf', cpf)
          // window.spinner.emit('open')
          MatriculaService.getPessoaByIdPessoaOuCpf( 0, drop ).then(
            response => {
              console.log("getPessoaByCpfOuNome - cpf:", response.data)
              const message = response.data.dados.Basicos.nomeDocumento ? ( response.data.dados.Basicos.nomeDocumento + " - " + cpf ) : cpf
              if ( response.data.dados ) {
                this.$refs.confirm.run({
                  message: "Encontramos uma pessoa com este CPF:<br><span class='color-text'>" + message + "</span><br>Os campos serão preenchidos com os dados desta pessoa.",
                  confirmButton: "Ok",
                  callback: this.populate,
                  data: response.data,
                  size: 'mid'
                })
              }
              window.spinner.emit('close')
            },
            error => {
              console.error(error)
              window.spinner.emit('close')
              const persistCpf = cpf

              const doc = cpf.length == 14 ? 'cpf' : 'cnpj'
              window.toaster.emit('open', {style: "error", message: "Não encontramos ninguém com o " + doc + " informado.", floater: true})
              // const doc = cpf.length == 14 ? 'cpf' : 'cnpj'
              this.$store.dispatch('matricula/clear', this.branch).then( response => {
                console.log("dispatch clear", response)
                console.log("dispatch branch", this.branch)
                this.matricula[this.branch] = response
                this.pessoa = this.matricula[this.branch]
                this.pessoa.documento.cpf = persistCpf
                window.toaster.emit('open', {style: "error", message: "Não encontramos ninguém com o " + doc + " informado.", floater: true})

                setTimeout(() => {
                  this.$emit('clearEndereco',response.endereco)
                },1000)
              })
              
            }
          )
        }
      }
    },
    validate () {
      const rg = this.pessoa?.Documento?.rg

      if ( this.isCNPJ && !rg ) {
        this.pessoa.documento.rg = '000000000'
      }

      this.pessoa.Basicos.idRacaCor = parseFloat(this.pessoa.Basicos.idRacaCor)

      const valid = FormService.validate(this.$refs.pessoaForm, this.valid)
      return valid
    },
    populate (status, data) {
      if ( status ) {
        delete data.dados.Basicos.imageBase64
          
        this.pessoa.Basicos = data.dados.Basicos
        if ( data.dados.Aluno ) {
          this.pessoa.aluno = data.dados.Aluno
        }
        // console.log("populate...", this.pessoa.Basicos)
        
        if ( !this.pessoa.Basicos.nomeDocumento ) {
          this.pessoa.Basicos.nomeDocumento = this.pessoa.Basicos.nome
        }
        
        this.pessoa.Basicos.dataNascimento = unformatDate(this.pessoa.Basicos.dataNascimento)
        // this.matricula.matricula.rm = 
        if ( data.dados.Documento ) {
          this.pessoa.documento = {
            idDocumento: data.dados.Documento.idDocumento,
            cpf: data.dados.Documento.cpf,
            idPessoa: data.dados.Documento.idPessoa,
            nomeOrgaoEmissor: data.dados.Documento.nomeOrgaoEmissor,
            rg: data.dados.Documento.rg,
            rgEmissor: data.dados.Documento.rgEmissor,
            possuiRestricao: data.dados.Documento.possuiRestricao
          }

          if ( ( this.branch == 'responsavel' || this.pessoa.responsavel?.financeiro == 1 ) && data.dados.Documento.possuiRestricao == 1 ) {
            window.toaster.emit('open', {style: "error", message: "O responsável selecionado tem restrições fiscais. Utilize outro responsável financeiro para seguir.", floater: true})
          }
        }
        if ( data.dados.Endereco ) {
          this.matricula[this.branch].endereco = data.dados.Endereco
          // this.$emit('populateEndereco', data.dados.Endereco)
        }
      }
    },
    stopSpinner () {
      const done = !Object.values(this.wait).includes(false)

      console.log('this.wait', this.wait)
      if ( done ) {
        window.spinner.emit("close")
        // this.$emit('onload')
        this.loadingInputContent = false

        console.log("CHEGOU AO FIM..")
      }
    },
    changeName () {
      if ( !this.pessoa.Basicos.nome ) {
        this.pessoa.Basicos.nome = this.pessoa.Basicos.nomeDocumento
      }
    },
    addCountryCode ( src, e ) {
      const iniCode = '+55'
      const escape = ['Enter', 'Backspace', 'ArrowUp', 'ArrowDown', 'ArrowLeft', 'ArrowRight', 'Tab', 'Escape']

      if ( !this.pessoa.Basicos[src] && !escape.includes(e.key) ) {
        this.pessoa.Basicos[src] = iniCode + this.pessoa.Basicos[src]
      }
    },
    triggerTip ( branch, field ) {
      window.mattip.emit("add", { branch, field })
    },
    triggerCpfChange ( action ) {
      if ( this.matricula ) {
        const cpf = this.pessoa?.Documento?.cpf

        if ( action === 'record' && cpf ) {
          this.cpfBkp = cpf
        }
        if ( action === 'change' && cpf && this.cpfBkp != cpf ) {
          this.pessoa.Basicos.idPessoa = null
          this.pessoa.Basicos.rescodigo = null
          this.pessoa.documento.idPessoa = null
          this.pessoa.documento.idDocumento = null
          this.pessoa.Endereco.idPessoa = null
          this.pessoa.Endereco.idEndereco = null
          if ( this.pessoa.Responsavel ) {
            this.pessoa.Responsavel.idPessoa = null
            this.pessoa.Responsavel.idresponsavel = null
          }
        }
      }
    },
    personType () {
      var doc = clearMask('cpf', this.pessoa?.Documento?.cpf || '')
      const isCNPJ = doc.length == 14
      this.isCNPJ = isCNPJ
      this.pessoa.Basicos.tipo = isCNPJ ? 2 : 1
    },
    requireCPF () {
      console.log("requireCPF:", this.matricula)
      if ( this.highrequire ) {
        return true
      } else {
        return this.matricula.matricula.requerCPF == 1
      }
    },
    validateDiaVencimento () {
      if ( !this.vencimentoResponsavelTotal ) {
        const origin = this.diaVencimentoBkp
        const dia = this.pessoa.Responsavel.diavencimento
        const limit = origin < 30 ? 30 : origin
        const newDay = dia > limit ? limit : dia

        if ( dia > limit ) {
          window.toaster.emit('open', {style: "error", message: "A data é limite é dia " + limit, floater: true})
        }

        this.pessoa.Responsavel.diavencimento = newDay
      }
    },
    validarFiscal () {
      const idMatricula = this.matricula.matricula.idMatricula
      const idPessoa = this.pessoa.Basicos.idPessoa
      const cpf = clearMask('cpf',this.pessoa.documento.cpf)

      // console.log('idMatricula:', idMatricula)
      // console.log('idPessoa:', idPessoa)
      // console.log('cpf:', cpf)
      const data = {
        idMatricula, idPessoa, cpf
      }

      window.spinner.emit('open')
      this.loadingInputContent = true

      matriculaService.consultarCPF( data )
      .then( response => {
        const { possuiRestricao } = response.data
        console.log('consultado...', possuiRestricao)
        if ( possuiRestricao ) {
          this.pessoa.documento.possuiRestricao = 1
          window.toaster.emit('open', {style: "error", message: "CPF com restrições. Não é possível continuar a matrícula com este responsável", floater: true})
        } else {
          this.pessoa.documento.possuiRestricao = 0
          window.toaster.emit('open', {style: "success", message: "Tudo certo! O cpf consultado não tem restrições. A página impressa do RedeCheck foi anexada aos documentos da matrícula.", floater: true})
        }
        console.log("response", response)
      })
      .catch( error => {
        const msg = error.response.data.errror
        window.toaster.emit('open', {style: "error", message: msg, floater: true})
        console.error(error)
      })
      .finally ( () => {
        window.spinner.emit('close')
        this.loadingInputContent = false
      })
    },
    toggleValidator ( type ) {
      if ( !this.canValidateContent(type) ) return

      if ( !this.validatorOn ) {
        this.validatorOn = true
        this.validatorType = type
        console.log('type:', type)
        const destination = this.matricula[this.branch].Basicos[type]
        console.log('destination:', destination)
        const { idPessoa } = this.pessoa.Basicos
        this.validatorContent = {
          destination,
          idPessoa,
          consent: true
        }

        // console.log('validatorContent:', this.validatorContent)

        const options = {
          title: 'Validação',
          titleAlign: "center",
          // message: "Escolha um novo operador para este atendimento", //não obrigatório
          size: "small", //small, mid, normal, large, full
          backdrop: true,
          backdropColor: "transparent",  //se o backdrop for false, não precisa
          backdropClose: true,
          onClose: () => {
            this.validatorOn = false
            this.validatorType = null
            this.validatorContent = null
          }
        }

        this.$refs.modal.open(options)
      } else {
        this.validatorOn = false
        this.validatorType = null
        this.validatorContent = null
      }
      // console.log("toggleTransfer:", options)

      // if ( type == 'telefone' ) {
      //   // console.log("this.pessoa.Basicos.telefonecelular:", this.pessoa.Basicos.telefonecelular.length)
      //   if ( this.pessoa.Basicos.telefonecelular && this.pessoa.Basicos.telefonecelular.length == 20 ) {
      //     this.validateCelular = true
      //     this.validateEmail = false
      //   }
      // }
      // if ( type == 'email' ) {
      //   if ( this.pessoa.Basicos.email ) {
      //     this.validateEmail = true
      //     this.validateCelular = false
      //   }
      // }
    },
    canValidateContent ( type ) {
      return this.hasValidatorContent(type) && !this.isValidatorContentValidated(type)
    },
    hasValidatorContent ( type ) {
      const value = this.pessoa?.Basicos?.[type]

      if ( type == 'telefonecelular' ) {
        return !!String(value || '').replace(/\D/g, '')
      }

      return !!String(value || '').trim()
    },
    isValidatorContentValidated ( type ) {
      const basicos = this.pessoa?.Basicos || {}
      const field = type == 'email'
        ? 'email_validated_at'
        : 'celular_validated_at'

      return !!String(basicos[field] || '').trim()
    },
    handleValidatorValidated ( type ) {
      if ( type == 'email' ) {
        this.pessoa.Basicos.email_validated_at = new Date().toISOString()
      }

      if ( type == 'telefonecelular' ) {
        this.pessoa.Basicos.celular_validated_at = new Date().toISOString()
      }
      this.$refs.modal.close()
    }
  }
}
</script>

<style lang="scss" scoped>
  .cpfValidatinWrap {
    padding-top: 27px
  }

  .input-button-wrap {
    display: flex; align-items: flex-end;
    gap: $mg_mini;
    width: 100%;
    >div {
      &:first-child {
        flex: 1
      }
    }
    .btn {
      margin-bottom: 7px;
    }
  }


</style>
